module.exports = __webpack_public_path__ + "a6c35e05e25005b1e9b0e7d013e5cb47.svg";